module.exports = __webpack_public_path__ + "static/img/create07.28f8cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create07.png
// module id = xx2c
// module chunks = 0